export const APP_VERSION = "1.0.0";
export let BUILD_NUMBER = 1;
